import routerOptions0 from "/workspace/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/workspace/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}